import React, { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { Target, PencilSimple, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ReadingGoalCard() {
  const year = new Date().getFullYear();
  const [data, setData] = useState(null);
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  function load() {
    api.get("/me/reading-goal").then(r => { setData(r.data); setValue(r.data.target || ""); }).catch(() => {});
  }
  useEffect(() => { load(); }, []);

  async function save() {
    const target = parseInt(value);
    if (!target || target < 1) { toast.error("Indica um número válido"); return; }
    setSaving(true);
    try {
      await api.put("/me/reading-goal", { year, target });
      toast.success("Meta atualizada");
      setEditing(false);
      load();
    } catch (err) { toast.error(formatError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  }

  if (!data) return null;
  const target = data.target;
  const read = data.read_count || 0;
  const pct = target ? Math.min(100, Math.round((read / target) * 100)) : 0;
  const done = target && read >= target;

  return (
    <div className="rounded-2xl border border-white/5 bg-[#0f0f14] p-4" data-testid="reading-goal-card">
      <div className="flex items-center justify-between mb-3">
        <div className="font-mono-accent text-[10px] text-zinc-400 flex items-center gap-1.5">
          <Target size={13} weight="fill" className="text-[#E63946]" /> META DE LEITURA {year}
        </div>
        {target != null && !editing && (
          <button onClick={() => setEditing(true)} className="text-zinc-500 hover:text-white" data-testid="edit-goal-btn" title="Editar meta">
            <PencilSimple size={13} weight="bold" />
          </button>
        )}
      </div>

      {target == null || editing ? (
        <div className="flex items-center gap-2">
          <input
            type="number" min="1" value={value} onChange={(e) => setValue(e.target.value)}
            placeholder="Ex: 24"
            className="flex-1 bg-[#1C1C22] border border-white/10 rounded-lg h-9 px-3 text-sm outline-none focus:border-[#E63946]/50"
            data-testid="goal-input"
          />
          <button onClick={save} disabled={saving} className="h-9 px-3 rounded-lg btn-crimson text-xs disabled:opacity-40" data-testid="save-goal-btn">
            {saving ? "..." : <Check size={16} weight="bold" />}
          </button>
        </div>
      ) : (
        <>
          <div className="flex items-end justify-between mb-2">
            <div className="font-display text-2xl font-extrabold">{read}<span className="text-zinc-500 text-lg"> / {target}</span></div>
            <div className={`font-mono-accent text-xs ${done ? "text-emerald-400" : "text-zinc-500"}`}>{done ? "CONCLUÍDA 🎉" : `${pct}%`}</div>
          </div>
          <div className="h-2.5 rounded-full bg-white/5 overflow-hidden">
            <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, background: done ? "#10B981" : "linear-gradient(90deg,#E63946,#7209B7)" }} />
          </div>
          <div className="text-[11px] text-zinc-500 mt-2">Mangás marcados como lidos em {year}</div>
        </>
      )}
    </div>
  );
}
